// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  PLATFORM_ADMIN: '/platform-admin',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    amplify: {
      signIn: `${ROOTS.AUTH}/amplify/sign-in`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      signUp: `${ROOTS.AUTH}/amplify/sign-up`,
      updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
      resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    },
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
    },
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
    auth0: {
      signIn: `${ROOTS.AUTH}/auth0/sign-in`,
    },
    supabase: {
      signIn: `${ROOTS.AUTH}/supabase/sign-in`,
      verify: `${ROOTS.AUTH}/supabase/verify`,
      signUp: `${ROOTS.AUTH}/supabase/sign-up`,
      updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
      resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    queues: `${ROOTS.DASHBOARD}/queues`,
    tasks: `${ROOTS.DASHBOARD}/tasks`,
  },
  report: {
    root: `${ROOTS.DASHBOARD}/report`,
    'call-logs': `${ROOTS.DASHBOARD}/report/call-logs`,
    'query-logs': `${ROOTS.DASHBOARD}/report/query-logs`,
    'active-calls': `${ROOTS.DASHBOARD}/report/active-calls`,
    'agent-status': `${ROOTS.DASHBOARD}/report/agent-status`,
    'agent-talktime': `${ROOTS.DASHBOARD}/report/agent-talktime`,
    voicemails: `${ROOTS.DASHBOARD}/report/voicemails`,
    'bulk-tools': `${ROOTS.DASHBOARD}/report/bulk-tools`,
  },
  users: {
    root: `${ROOTS.DASHBOARD}/users`,
    'users-list': `${ROOTS.DASHBOARD}/users/list`,
    'user-create': `${ROOTS.DASHBOARD}/users/create`,
  },
  contacts: {
    root: `${ROOTS.DASHBOARD}/contacts`,
  },
  analysis: {
    root: `${ROOTS.DASHBOARD}/data-import`,
    analytics: `${ROOTS.DASHBOARD}/analytics`,
  },
  chat: {
    root: `${ROOTS.DASHBOARD}/chat`,
    'whats-app': `${ROOTS.DASHBOARD}/chat/whatsapp`,
    'message-chat': `${ROOTS.DASHBOARD}/chat/sms`,
  },
  configuration: {
    root: `${ROOTS.DASHBOARD}/analytics/configuration`,
  },
  settings: {
    apiIntegration: `${ROOTS.DASHBOARD}/settings/api-integration`,
  },
  platformAdmin: {
    root: ROOTS.PLATFORM_ADMIN,
    tenants: {
      root: `${ROOTS.PLATFORM_ADMIN}/tenants`,
      detail: (tenantUuid) => `${ROOTS.PLATFORM_ADMIN}/tenants/${tenantUuid}`,
    },
    provisioning: {
      requests: `${ROOTS.PLATFORM_ADMIN}/provisioning/requests`,
      requestDetail: (requestUuid) =>
        `${ROOTS.PLATFORM_ADMIN}/provisioning/requests/${requestUuid}`,
    },
    license: `${ROOTS.PLATFORM_ADMIN}/license`,
    usage: `${ROOTS.PLATFORM_ADMIN}/usage`,
    systemHealth: `${ROOTS.PLATFORM_ADMIN}/system-health`,
    backgroundJobs: `${ROOTS.PLATFORM_ADMIN}/background-jobs`,
    celeryStatus: `${ROOTS.PLATFORM_ADMIN}/celery-status`,
    apiHealth: `${ROOTS.PLATFORM_ADMIN}/api-health`,
    auditLogs: `${ROOTS.PLATFORM_ADMIN}/audit-logs`,
    users: `${ROOTS.PLATFORM_ADMIN}/users`,
    settings: `${ROOTS.PLATFORM_ADMIN}/settings`,
    tenantApiManagement: `${ROOTS.PLATFORM_ADMIN}/tenant-api-management`,
    apiDocumentation: `${ROOTS.PLATFORM_ADMIN}/api-documentation`,
    liveCalls: `${ROOTS.PLATFORM_ADMIN}/live-calls`,
    sipRegistrations: `${ROOTS.PLATFORM_ADMIN}/sip-registrations`,
    voiceQuality: `${ROOTS.PLATFORM_ADMIN}/voice-quality`,
    tenantHealth: `${ROOTS.PLATFORM_ADMIN}/tenant-health`,
    activeAlerts: `${ROOTS.PLATFORM_ADMIN}/active-alerts`,
    callHistory: `${ROOTS.PLATFORM_ADMIN}/call-history`,
    // The same report a tenant sees at /dashboard/report/agent-talktime,
    // reached from the platform portal because a Platform Admin is served
    // the platform nav, not the tenant one - and only here does it offer a
    // tenant picker.
    agentTalktime: `${ROOTS.PLATFORM_ADMIN}/agent-talktime`,
    // Deep link for one call - shareable in a ticket, and the "open full
    // page" target of the Call Details drawer.
    callDetail: (callUuid) => `${ROOTS.PLATFORM_ADMIN}/calls/${callUuid}`,
  },
};
